import { Layout } from 'components/layout';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';

import { Routes } from 'constants/routes';
import { IBlogPost, IGuidePostCategory } from 'constants/types';

import { Icon } from 'common/icon';
import { Breadcrumbs } from 'components/bredcrambs';
import { FAQComponent } from 'components/casino-faq';
import { Title } from 'components/title';
import { Anchor } from 'constants/anchors';
import { guidesPage } from 'constants/routes-breadcrumbs';
import { INavItem } from 'constants/types';
import { NavigationBar } from '../casino/casino-navigations';
import { News } from '../home/news';
import { NewsBlock } from '../blogs-and-news-page/block';
import { GuidesDescription } from './description';
import styles from './styles.module.css';

export type Props = {
  top: IBlogPost[];
  postsOtherCategory: IBlogPost[];
  postsCasinosCategory: IBlogPost[];
  postsSlotsCategory: IBlogPost[];
  postsRtpChecksCategory: IBlogPost[];
  category?: IGuidePostCategory;
};

const navItems: INavItem[] = [
  {
    icon: <Icon.Bonuses />,
    text: 'Casinos',
    anchor: `#${Anchor.GuidesCategoryCasino}`,
  },

  {
    icon: <Icon.Cherry width="18" height="18" fill="white" />,
    text: 'Slots',
    anchor: `#${Anchor.GuidesCategorySlots}`,
  },

  {
    icon: <Icon.Search width="16" height="16" />,
    text: 'RTP Checks',
    anchor: `#${Anchor.GuidesCategoryRtpChecks}`,
  },

  {
    icon: <Icon.Other />,
    text: 'Other',
    anchor: `#${Anchor.GuidesCategoryOther}`,
  },
];

export const GuidesPage = ({
  top,
  postsCasinosCategory,
  postsSlotsCategory,
  postsRtpChecksCategory,
  postsOtherCategory,
}: Props) => {
  return (
    <div>
      <CustomMetadata metadata={allMetadata.guides} />

      <Layout hasFooter isSearchInputMobileVisible bgVariant="basic">
        <main className={styles.main}>
          <div className={styles.container_s}>
            <div className={styles.breadcrumbs}>
              <Breadcrumbs items={[...guidesPage]} />
            </div>
            <Title
              text={'All About Online Gambling in One Place'}
              description="We've created the ultimate online casino guide. If you play for real money, you need to know these essentials to keep your money safe and maximize your enjoyment"
              gap={20}
            />
            <NewsBlock posts={top} type="guide" />
            <NavigationBar
              items={navItems}
              navItemClassName={styles.navItem}
              variantBg="notransparent"
              variantPadding="big"
            />
            <News
              maxLines={2}
              title={'Casinos'}
              data={postsCasinosCategory}
              anchor={Anchor.GuidesCategoryCasino}
              url={Routes.guidesCasinos}
              arrow={false}
              variant={'base'}
            />
            <News
              maxLines={2}
              title={'Slots'}
              data={postsSlotsCategory}
              anchor={Anchor.GuidesCategorySlots}
              url={Routes.guidesSlots}
              arrow={false}
              variant={'base'}
            />
            <News
              maxLines={2}
              title={'RTP Checks'}
              data={postsRtpChecksCategory}
              anchor={Anchor.GuidesCategoryRtpChecks}
              url={Routes.guidesRtpChecks}
              arrow={false}
              variant={'base'}
            />
            <News
              maxLines={2}
              title={'Other'}
              data={postsOtherCategory}
              anchor={Anchor.GuidesCategoryOther}
              url={Routes.guidesOther}
              arrow={false}
              variant={'base'}
            />

            <GuidesDescription />

            <FAQComponent
              customFaq={[
                {
                  title: 'What is online gambling?',
                  description:
                    'Online gambling refers to the act of placing bets on games of chance or skill via the internet. It includes games such as slots, roulette, poker, and sports betting.',
                },
                {
                  title: 'Is online gambling legal?',
                  description:
                    "The legality of online gambling varies depending on your location. Always check local laws and regulations to ensure you're complying with legal requirements.",
                },
                {
                  title: 'How do I choose a safe online casino?',
                  description:
                    'Look for licensed casinos with secure payment methods, positive player reviews, and strong encryption protocols. Always verify that the casino holds a valid gambling license.',
                },
                {
                  title: 'What payment methods can I use at online casinos?',
                  description:
                    'Most online casinos offer a variety of payment methods including credit/debit cards, e-wallets (e.g., PayPal, Neteller), and even cryptocurrencies like Bitcoin.',
                },
                {
                  title: 'How do casino bonuses work?',
                  description:
                    'Casino bonuses are promotional offers that give players extra funds or free spins. These bonuses often come with terms and conditions, such as wagering requirements.',
                },
                {
                  title: 'Can I play casino games on my mobile phone?',
                  description:
                    'Yes, many online casinos offer mobile-friendly platforms or dedicated apps for iOS and Android devices, allowing you to play anywhere, anytime.',
                },
                {
                  title: 'How do I know when to stop playing?',
                  description:
                    'It’s important to set limits for yourself and play responsibly. If you feel that gambling is affecting your life or causing distress, it’s time to stop and seek help.',
                },
              ]}
            />
          </div>
        </main>
      </Layout>
    </div>
  );
};
